export function SiteDevIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#prefix__clip0_801_130)"
        stroke="#5200FF"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 26h6M12 14l6 5-6 5" />
        <path d="M32 38H8a6 6 0 01-6-6V8a6 6 0 016-6h24a6 6 0 016 6v24a6 6 0 01-6 6z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_801_130">
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ReDesignIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.53 26.1V15.264M34.056 32.315l2.997-6.078-7.52-10.974-7.522 10.974 2.997 6.078M25.008 32.315h9.047V38h-9.047v-5.684zM25.389 5.215C17.945 7.07 12.42 13.777 12.42 21.794M26.158 5.221L8.632 5.202M5.79 8.052a2.843 2.843 0 010-5.685 2.843 2.843 0 010 5.685zM30.895 8.632h-2.843a1.895 1.895 0 01-1.894-1.895V3.895c0-1.046.848-1.895 1.894-1.895h2.843c1.045 0 1.894.849 1.894 1.895v2.842a1.895 1.895 0 01-1.895 1.895zM13.842 28.426H11a1.895 1.895 0 01-1.895-1.895v-2.842c0-1.046.85-1.895 1.895-1.895h2.842c1.046 0 1.895.849 1.895 1.895v2.842a1.894 1.894 0 01-1.895 1.895z"
        stroke="#5200FF"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CommerceIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.5 17.158v-7.58C27.5 5.394 24.142 2 20 2c-4.142 0-7.5 3.393-7.5 7.579v7.579"
        stroke="#5200FF"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.125 38H6.875A1.886 1.886 0 015 36.105V13.37c0-1.046.84-1.895 1.875-1.895h26.25c1.035 0 1.875.849 1.875 1.894v22.737C35 37.151 34.16 38 33.125 38z"
        stroke="#5200FF"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function DesignDevLogoIcon(props) {
  return (
    <svg
      width={44}
      height={44}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 20.57v3L20 27l4-10 8 3.43v3L26 27l6-3.57v-3L24 17l-4 10-8-3.43v-3zm0 0L18 17l-6 3.57z"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 42c11.046 0 20-8.954 20-20S33.046 2 22 2 2 10.954 2 22s8.954 20 20 20z"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function DesignIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30 8.285c1.85-.317 3.788-.5 5.912-.569C37.048 7.68 38 8.533 38 9.61v22.428c0 1.027-.866 1.876-1.948 1.891-6.184.09-10.84 1.17-16.052 4.072-5.212-2.903-9.868-3.983-16.052-4.07C2.866 33.915 2 33.064 2 32.037V9.61c0-1.059.918-1.929 2.034-1.894C10.176 7.902 14.812 8.997 20 11.75"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 27.083V3.918c0-1.382-1.532-2.346-2.834-1.727C23.654 3.86 20.694 7.25 20 10.74V38c.792-3.977 4.522-7.823 8.662-9.14.804-.256 1.338-.974 1.338-1.777z"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function StyleIcon(props) {
  return (
    <svg
      width={36}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34 8v27.997a2 2 0 01-3.2 1.6L18 28 5.2 37.597a2 2 0 01-3.2-1.6V8a6 6 0 016-6h20a6 6 0 016 6z"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 28.356l-16-12-16 12"
        stroke="#FF7A00"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function SeoIcon(props) {
  return (
    <svg
      width={60}
      height={60}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.25 52.5h37.5-.024c2.05 0 3.75-1.7 3.75-3.75v-7.525c0-2.075-1.7-3.75-3.75-3.75h-37.55a3.745 3.745 0 00-3.75 3.75v7.5c0 2.05 1.675 3.725 3.75 3.725l.075.05z"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.575 15.125l-4.8 4.775-2.875-2.875"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.502 10H11.227a3.745 3.745 0 00-3.75 3.75v7.5c0 2.05 1.675 3.725 3.75 3.725h16.25"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.75 6.25a11.25 11.25 0 100 22.5 11.25 11.25 0 000-22.5z"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SmmIcon(props) {
  return (
    <svg
      width={60}
      height={60}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 12a9 9 0 019-9h36a9 9 0 019 9v43.5a1.5 1.5 0 01-2.295 1.272l-9.231-5.77H12a9 9 0 01-9-9V12z"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 24h26M17 32h26"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function MarketingIcon(props) {
  return (
    <svg
      width={60}
      height={60}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.051 37.53l-14.94-.005C8.08 37.525 4 33.414 4 28.344v-2.288c0-5.07 4.08-9.178 9.113-9.178h14.94l8.82-6.07c3.025-2.081 7.127.1 7.127 3.79v25.216c0 3.69-4.105 5.871-7.127 3.788l-8.822-6.073zM28.055 16.882V37.53"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.834 37.53l3.483 8.85A4.098 4.098 0 0018.12 49c2.895 0 4.876-2.969 3.808-5.706l-2.253-5.765"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 23v7.5M56 20v14"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function MarketplaceIcon(props) {
  return (
    <svg
      width={60}
      height={60}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M44.445 15.556v-2.89a8.667 8.667 0 10-17.334 0v2.89"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.89 53.111H50.22A5.778 5.778 0 0056 47.333v-26a5.778 5.778 0 00-5.778-5.777H21.333a5.778 5.778 0 00-5.778 5.777V30"
        stroke="#FFC635"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.777 56h23.111a5.778 5.778 0 005.778-5.778V35.778A5.778 5.778 0 0032.888 30H9.778a5.778 5.778 0 00-5.779 5.778v14.444A5.778 5.778 0 009.777 56z"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.555 38.667v1.444a5.778 5.778 0 0011.555 0v-1.444"
        stroke="#fff"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HostingIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.5 6.29h-8.442c-.662 0-1.282-.318-1.654-.852l-1.81-2.588A2.015 2.015 0 0015.942 2H10.5c-2.21 0-4 1.742-4 3.892v15.567c0 2.15 1.79 3.892 4 3.892h19c2.21 0 4-1.741 4-3.892V10.183c0-2.149-1.79-3.892-4-3.892zM20 25.39v6.772M23 35.081h13M4 35.081h13M22.121 33.017a2.863 2.863 0 010 4.128 3.06 3.06 0 01-4.242 0 2.863 2.863 0 010-4.128 3.06 3.06 0 014.242 0z"
        stroke="#0093D1"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function VebIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#prefix__clip0_821_560)"
        stroke="#0093D1"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M26.325 35l-2.92 3M15.622 38H11.73a9.599 9.599 0 01-6.88-2.929A10.143 10.143 0 012 28V12c0-2.652 1.025-5.196 2.85-7.071A9.598 9.598 0 0111.73 2h15.567a9.598 9.598 0 016.88 2.929A10.143 10.143 0 0137.027 12v4M11.73 12v16M19.514 12v8M27.297 12v4" />
        <path d="M31.189 37c3.761 0 6.81-3.134 6.81-7s-3.049-7-6.81-7c-3.762 0-6.811 3.134-6.811 7s3.05 7 6.81 7z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_821_560">
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SupportIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#prefix__clip0_821_571)"
        stroke="#0093D1"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21.888 15.394a5.099 5.099 0 010 7.212 5.099 5.099 0 01-7.212 0 5.099 5.099 0 010-7.212 5.099 5.099 0 017.212 0z" />
        <path d="M31.032 19c0-.562-.05-1.122-.118-1.666l3-2.346a1.7 1.7 0 00.424-2.184L31.67 8.19a1.699 1.699 0 00-2.1-.726L26.89 8.54c-.532.214-1.126.124-1.606-.192a12.917 12.917 0 00-1.288-.748c-.512-.256-.886-.724-.968-1.29l-.408-2.856A1.693 1.693 0 0020.942 2h-5.32c-.843 0-1.559.62-1.679 1.454l-.412 2.86c-.08.564-.452 1.03-.96 1.288-.446.228-.878.482-1.292.756-.478.314-1.07.398-1.6.186l-2.684-1.08a1.694 1.694 0 00-2.1.726l-2.668 4.614a1.696 1.696 0 00.422 2.184l3 2.346A13.47 13.47 0 005.53 19c0 .56.05 1.122.12 1.666l-3 2.346a1.699 1.699 0 00-.424 2.184l2.668 4.614a1.699 1.699 0 002.1.726l2.686-1.078c.53-.214 1.122-.128 1.598.188.416.276.846.528 1.292.756.51.258.88.722.962 1.288l.41 2.858c.12.832.836 1.452 1.678 1.452h2.663M26 28h12M26 33h12M26 38h12" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_821_571">
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BgDev(props) {
  return (
    <svg
      width={1896}
      height={951}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1512 3l-384 384 384 384 384-384L1512 3z"
        fill="#6851F3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M564-177L0 387l564 564 564-564-564-564z"
        fill="#6551E3"
      />
    </svg>
  );
}
export function BgDesign(props) {
  return (
    <svg
      width={2054}
      height={1747}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity={0.9} cx={1664} cy={1357} r={390} fill="#FFCA63" />
      <circle opacity={0.9} cx={1478} cy={-78} r={390} fill="#FFCA63" />
      <circle opacity={0.9} cx={445} cy={336} r={445} fill="#FBA31F" />
    </svg>
  );
}
export function BgSeo(props) {
  return (
    <svg
      width={1901}
      height={918}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M486.928 480L622 169 311 304.072 0 169l135.072 311L0 791l311-135.072L622 791 486.928 480z"
        fill="#42FFB0"
      />
      <path
        d="M1442 0l129.82 329.175L1901 459l-329.18 129.825L1442 918l-129.82-329.175L983 459l329.18-129.825L1442 0z"
        fill="#00CF85"
      />
    </svg>
  );
}
export function BgSupport(props) {
  return (
    <svg
      width={1440}
      height={674}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1440 768L996 0 552 768h888z"
        fill="#4F8ABF"
      />
      <path
        opacity={0.4}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M685 708L460 319 235 708h450z"
        fill="#53A0E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0l263 152L0 304V0z"
        fill="#396894"
      />
    </svg>
  );
}
export function BgDevMiddle(props) {
  return (
    <svg
      width={1386}
      height={1159}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1029 0L672 357l357 357 357-357L1029 0z"
        fill="#6851F3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M579.5 0L0 579.5 579.5 1159 1159 579.5 579.5 0z"
        fill="#6551E3"
      />
    </svg>
  );
}
export function BgDevSmall(props) {
  return (
    <svg
      width={1296}
      height={1318}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M954 634L612 976l342 342 342-342-342-342z"
        fill="#6851F3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M405 0L0 405l405 405 405-405L405 0z"
        fill="#6551E3"
      />
    </svg>
  );
}
export function BgDesignMiddle(props) {
  return (
    <svg
      width={1252}
      height={1272}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity={0.9} cx={862} cy={1116} r={390} fill="#FFCA63" />
      <circle opacity={0.9} cx={390} cy={-146} r={390} fill="#FFCA63" />
    </svg>
  );
}
export function BgDesignSmall(props) {
  return (
    <svg
      width={816}
      height={1318}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity={0.9} cx={195} cy={1123} r={195} fill="#FFCA63" />
      <circle opacity={0.9} cx={640.5} cy={-0.5} r={175.5} fill="#FFCA63" />
    </svg>
  );
}
export function BgSeoMiddle(props) {
  return (
    <svg
      width={1455}
      height={992}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M959 0l140.29 355.71L1455 496l-355.71 140.29L959 992 818.71 636.29 463 496l355.71-140.29L959 0z"
        fill="#00CF85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306.874 274L392 78l-196 85.126L0 78l85.126 196L0 470l196-85.126L392 470l-85.126-196z"
        fill="#42FFB0"
      />
    </svg>
  );
}
export function BgSeoSmall(props) {
  return (
    <svg
      width={650}
      height={1318}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M435.309 195L520 0 325 84.691 130 0l84.691 195L130 390l195-84.691L520 390l-84.691-195z"
        fill="#42FFB0"
      />
      <path
        d="M325 668l91.924 233.076L650 993l-233.076 91.92L325 1318l-91.924-233.08L0 993l233.076-91.924L325 668z"
        fill="#00CF85"
      />
    </svg>
  );
}
export function BgSupportSmall(props) {
  return (
    <svg
      width={819}
      height={684}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M819 708L409.5 0 0 708h819z"
        fill="#4F8ABF"
      />
    </svg>
  );
}
export function CloseIcon({ mainClassName }) {
  return (
    <svg
      width={40}
      height={40}
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M8 8l24 24M32 8L8 32"
        stroke="#8D90AB"
        strokeWidth={4}
        strokeLinecap="round"
      />
    </svg>
  );
}
export function CloseIconMobile({ mainClassName }) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M4.8 4.8l14.4 14.4M19.2 4.8L4.8 19.2"
        stroke="#8D90AB"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function LikeIcon({ mainClassName }) {
  return (
    <svg
      width={24}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M16.933 0C21.16 0 24 4.098 24 7.92 24 15.661 12.213 22 12 22c-.213 0-12-6.339-12-14.08C0 4.098 2.84 0 7.067 0 9.493 0 11.08 1.251 12 2.351 12.92 1.251 14.507 0 16.933 0z"
        fill="#fff"
      />
    </svg>
  );
}
export function LikeIconMobile({ mainClassName }) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M10.878 2C13.343 2 15 4.421 15 6.68 15 11.254 8.124 15 8 15c-.124 0-7-3.746-7-8.32C1 4.421 2.657 2 5.122 2 6.538 2 7.463 2.74 8 3.39 8.537 2.74 9.462 2 10.878 2z"
        fill="#fff"
      />
    </svg>
  );
}

export function ShareIcon({ mainClassName, strokeClassName }) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M17.857 10.333h2.572c1.42 0 2.571 1.094 2.571 2.444v9.778C23 23.905 21.85 25 20.43 25H7.572C6.152 25 5 23.905 5 22.555v-9.777c0-1.35 1.152-2.445 2.572-2.445h2.571M14 17.667V3M17.857 6.667L14 3l-3.857 3.667"
        stroke="#000536"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={strokeClassName}
      />
    </svg>
  );
}
export function ShareIconMobile({ mainClassName, strokeClassName }) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
    >
      <path
        d="M10.204 5.904h1.47c.811 0 1.469.626 1.469 1.397v5.588c0 .77-.658 1.396-1.47 1.396H4.328c-.812 0-1.47-.625-1.47-1.396V7.3c0-.771.658-1.397 1.47-1.397h1.47M8 10.095V1.714M10.204 3.81L8 1.713 5.796 3.809"
        stroke="#000536"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={strokeClassName}
      />
    </svg>
  );
}
export function ArrowIcon(props) {
  return (
    <svg
      width={24}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 26a1.5 1.5 0 003 0h-3zM13.06.94a1.5 1.5 0 00-2.12 0l-9.547 9.545a1.5 1.5 0 102.122 2.122L12 4.12l8.485 8.486a1.5 1.5 0 102.122-2.122L13.06.94zM13.5 26V2h-3v24h3z"
        fill="#fff"
      />
    </svg>
  );
}

export const ProjectLogoIcon = ({ mainClassName, fillClassName }) => {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="240"
      height="58"
      viewBox="0 0 240 58"
      fill="none"
    >
      <path
        className={fillClassName}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.9114 0V57.2088H100.162V0H89.9114ZM160.81 58C157.367 58 154.263 57.1296 151.499 55.3888C148.734 53.648 146.569 51.2742 145.004 48.2674C143.439 45.2605 142.657 41.8845 142.657 38.1391C142.657 34.341 143.439 30.9386 145.004 27.9317C146.569 24.9249 148.734 22.5511 151.499 20.8103C154.263 19.0695 157.367 18.1991 160.81 18.1991C163.522 18.1991 165.948 18.753 168.087 19.8608C169.508 20.5972 170.734 21.5318 171.764 22.6646V18.9904H181.936V57.2087H171.764V53.4992C170.734 54.6204 169.508 55.5668 168.087 56.3383C165.948 57.4461 163.522 58 160.81 58ZM162.688 48.4256C165.557 48.4256 167.878 47.4761 169.652 45.5771C171.425 43.6253 172.312 41.1196 172.312 38.06C172.312 36.0554 171.895 34.2883 171.06 32.7585C170.277 31.1759 169.156 29.9627 167.695 29.1186C166.287 28.2219 164.618 27.7735 162.688 27.7735C160.81 27.7735 159.141 28.2219 157.68 29.1186C156.272 29.9627 155.15 31.1759 154.315 32.7585C153.533 34.2883 153.142 36.0554 153.142 38.06C153.142 40.1173 153.533 41.9372 154.315 43.5198C155.15 45.0495 156.272 46.2628 157.68 47.1596C159.141 48.0036 160.81 48.4256 162.688 48.4256ZM106.582 51.2747L124.267 28.0114H107.99V18.9909H138.976V24.9254L121.291 48.1888H138.506V57.2093H106.582V51.2747ZM63.124 57.9998C59.3161 57.9998 55.8733 57.1294 52.7957 55.3886C49.7702 53.5951 47.3446 51.1949 45.5188 48.188C43.7453 45.1285 42.8585 41.726 42.8585 37.9807C42.8585 34.2353 43.7453 30.8856 45.5188 27.9315C47.2924 24.9247 49.718 22.5509 52.7957 20.8101C55.8733 19.0166 59.29 18.1198 63.0458 18.1198C66.9059 18.1198 70.3487 19.0166 73.3742 20.8101C76.4518 22.5509 78.8774 24.9247 80.651 27.9315C82.4245 30.8856 83.3113 34.2353 83.3113 37.9807C83.3113 41.726 82.4245 45.1285 80.651 48.188C78.8774 51.1949 76.4518 53.5951 73.3742 55.3886C70.3487 57.1294 66.932 57.9998 63.124 57.9998ZM63.0458 48.3463C64.9758 48.3463 66.6712 47.9243 68.1317 47.0803C69.6445 46.1835 70.7921 44.9702 71.5745 43.4404C72.4091 41.8579 72.8265 40.0643 72.8265 38.0598C72.8265 36.0552 72.4091 34.2881 71.5745 32.7583C70.7399 31.2285 69.5923 30.0416 68.1317 29.1976C66.6712 28.3008 64.9758 27.8524 63.0458 27.8524C61.1679 27.8524 59.4987 28.3008 58.0381 29.1976C56.5775 30.0416 55.4299 31.2285 54.5953 32.7583C53.7607 34.2881 53.3434 36.0552 53.3434 38.0598C53.3434 40.0643 53.7607 41.8579 54.5953 43.4404C55.4299 44.9702 56.5775 46.1835 58.0381 47.0803C59.4987 47.9243 61.1679 48.3463 63.0458 48.3463ZM10.6414 36.5568V57.209H0V1.58266H7.82453H10.6414H21.674C25.1689 1.58266 28.2987 2.2948 31.0634 3.71908C33.8802 5.14337 36.0972 7.1743 37.7142 9.81186C39.3313 12.3967 40.1398 15.4826 40.1398 19.0697C40.1398 22.6568 39.3313 25.7691 37.7142 28.4067C36.0972 30.9915 33.8802 32.9961 31.0634 34.4204C28.2987 35.8447 25.1689 36.5568 21.674 36.5568H10.6414ZM10.6414 10.3658V27.7737H20.5785C22.2478 27.7737 23.7605 27.4308 25.1167 26.745C26.473 26.0593 27.5424 25.0834 28.3248 23.8173C29.1073 22.4986 29.4985 20.916 29.4985 19.0697C29.4985 17.2762 29.1073 15.72 28.3248 14.4012C27.5424 13.0824 26.473 12.0802 25.1167 11.3944C23.7605 10.7086 22.2478 10.3658 20.5785 10.3658H10.6414Z"
        fill="#232A72"
      />
      <rect
        x="189.678"
        y="5.7998"
        width="11.6129"
        height="11.6"
        fill="#FF8585"
      />
      <rect
        x="209.033"
        y="5.7998"
        width="11.6129"
        height="11.6"
        fill="#FFB84F"
      />
      <rect
        x="228.387"
        y="5.7998"
        width="11.6129"
        height="11.6"
        fill="#7AE448"
      />
    </svg>
  );
};

export const PopupCloseIcon = ({ mainClassName, strokeClassName }) => {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_2465_10516)">
        <path
          className={strokeClassName}
          d="M14 2L2 14"
          stroke="#696E87"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
        <path
          className={strokeClassName}
          d="M2 2L14 14"
          stroke="#696E87"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2465_10516">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlankRhomb = ({ mainClassName, fillClassName }) => {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="1373"
      height="795"
      viewBox="0 0 1373 795"
      fill="none"
    >
      <path
        className={fillClassName}
        d="M686.218 0L1372.44 397.25L686.218 794.5L0 397.25L686.218 0Z"
      />
    </svg>
  );
};

export const PlankCloseIcon = ({
  mainClassName,
  fillClassName,
  bgClassName,
}) => {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="78"
      height="78"
      viewBox="0 0 78 78"
      fill="none"
    >
      <rect
        className={bgClassName}
        width="78"
        height="78"
        rx="39"
        fill="white"
      />
      <rect
        className={fillClassName}
        x="52.4355"
        y="18.4939"
        width="10"
        height="48"
        rx="2"
        transform="rotate(45 52.4355 18.4939)"
        fill="#434661"
      />
      <rect
        className={fillClassName}
        x="18.4941"
        y="25.5649"
        width="10"
        height="48"
        rx="2"
        transform="rotate(-45 18.4941 25.5649)"
        fill="#434661"
      />
    </svg>
  );
};

export const PlankArrowIcon = ({ mainClassName, strokeClassName }) => {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
    >
      <path
        className={strokeClassName}
        d="M30 30L4 4"
        stroke="#F73F34"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className={strokeClassName}
        d="M29.9008 7.10889V29.8997L7.11328 29.8964"
        stroke="#F73F34"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LightningIcon = ({ mainClassName, fillClassName }) => {
  return (
    <svg
      className={mainClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="57"
      height="72"
      viewBox="0 0 57 72"
      fill="none"
    >
      <path
        className={fillClassName}
        d="M32.3013 0L0 44H28.5L24.6987 72L57 28H28.5L32.3013 0Z"
        fill="#F73F34"
      />
    </svg>
  );
};
